<template>
  <div class="content">
    <div class="row">
      <div class="col-sm-2"></div>
    </div>
    <div class="row">
      <div class="col-sm-1">아이디</div>
      <div class="col-sm-1">상위아이디</div>
      <div class="col-sm-1">카테고리</div>
      <div class="col-sm-1">컨텐츠아이디</div>
      <div class="col-sm-4">내용</div>
      <div class="col-sm-1">알림시간</div>
      <div class="col-sm-1">등록일</div>
      <div class="col-sm-1">단건삭제</div>
      <div class="col-sm-1">전체삭제</div>
    </div>
    <hr />
    <div class="row handle" v-for="(item, index) in data">
      <div class="col-sm-1">{{ item.id }}</div>
      <div class="col-sm-1">{{ item.parentId }}</div>
      <div class="col-sm-1">{{ item.namespace }}</div>
      <div class="col-sm-1">{{ item.contentId }}</div>
      <div class="col-sm-4 metadata">{{ item.metadata }}</div>
      <div class="col-sm-1">{{ item.notificationTime | formatDateTime }}</div>
      <div class="col-sm-1">{{ item.regTime | formatDateTime }}</div>
      <div class="col-sm-1">
        <base-button @click.native="deleteReservedNotification(item.id)" type="warning" size="sm" icon>
          <i class="tim-icons el-icon-minus" />
        </base-button>
      </div>
      <div class="col-sm-1">
        <base-button @click.native="deleteReservedNotificationWithParentId(item.parentId)" type="warning" size="sm" icon>
          <i class="tim-icons el-icon-minus" />
        </base-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  async created() {
    await this.getData();
  },
  data() {
    return {
      data: [],
    };
  },
  methods: {
    async deleteReservedNotification(id) {
      if (!id) {
        Toast.error("아이디가 없습니다");
        return;
      }
      await this.$axios.delete(`/notification/reservedNotification/${id}`);
      await this.getData();
    },
    async deleteReservedNotificationWithParentId(parentId) {
      if (!parentId) {
        Toast.error("상위아이디가 없습니다");
        return;
      }
      await this.$axios.delete(`/notification/reservedNotification/${parentId}/all`);
      await this.getData();
    },
    async getData() {
      await this.$axios.get("/notification/reservedNotification").then((res) => {
        this.data = res.data.data.map((d) => {
          const metadata = JSON.parse(d.metadata);
          d.title = metadata.title;
          d.message = metadata.message;
          return d;
        });
      });
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
.metadata {
  width: 200px;
  padding: 10px;
  max-height: 50px; /* 기본 높이 */
  overflow: hidden; /* 내용이 넘칠 경우 숨기기 */
  transition: max-height 0.3s ease; /* 부드러운 전환 효과 */
}
.metadata:hover {
  max-height: 200px;
}
</style>
